module.exports = __webpack_public_path__ + "static/media/hall.e0d2bd69.jpg";